<script lang="ts">
	// UI
	import SearchLinks from "../component/Side/SearchLinks.svelte";
	import SelectedStore from "../component/Side/SelectedStore.svelte";
	import StoreLinks from "../component/Side/StoreLinks.svelte";
	//Modules
	import { popup } from "@hitit/hub/src/v7/store";
	import { i18n } from "@hitit/hub/src/stores";
	import { GlobalIcon } from "@hitit/new_ui";
	import { onDestroy, onMount } from "svelte";
	import { navigate } from "svelte-routing";
	import { detectMob } from "@hitit/hub/src/v7/utils";
	// Type
	import type { StoreData } from "@hitit/api";

	// Props
	export let store: StoreData | undefined = undefined;
	//constants
	const isMobile = detectMob();
	const hamburgerHandler = () => (openSide = !openSide);
	const globalHandler = () => (globalOpen = !globalOpen);
	const resetHandler = () => {
		openSide = false;
		globalOpen = false;
		accountDrop = false;
	};
	const windowEvent = (e: Event) => {
		const t = e.target as HTMLElement;

		if (global === t || global.contains(t) || globalOpen === false) {
			return;
		}

		globalOpen = false;
	};
	const languages = [
		{ lang: "ko", label: "한국어" },
		{ lang: "en", label: "ENGLISH" },
	];
	//variables
	let openSide = false;
	let globalOpen = false;
	let accountDrop = false;
	let global: HTMLDivElement;

	onMount(() => window.addEventListener("click", windowEvent));
	onDestroy(() => window.removeEventListener("click", windowEvent));
	$: isMobile &&
		(openSide
			? document.body.classList.add("scroll-block")
			: document.body.classList.remove("scroll-block"));
</script>

<main>
	<div class="hamburger" class:open={openSide} on:click={hamburgerHandler}>
		<span />
	</div>
	<div class="container-cover" class:open={openSide} on:click={resetHandler} />
	<div class="side" class:open={openSide}>
		<img
			src="/img/MBRLogo.png"
			id="logo"
			alt="logo"
			on:click={() => {
				navigate("/");
				resetHandler();
			}}
		/>
		<SearchLinks linkClickAfterHanlder={resetHandler} />
		{#if store}
			<div class="store-box">
				<SelectedStore store={store} />
			</div>
			<StoreLinks storeId={store.id} linkClickAfterHanlder={resetHandler} />
		{/if}
		<div class="global" bind:this={global}>
			<GlobalIcon active={globalOpen} on:click={globalHandler} />
		</div>
		{#if globalOpen}
			<div class="language-box">
				{#each languages as lang}
					<button
						on:click={() => {
							$i18n.changeLanguage(lang.lang);
							$i18n = $i18n;
							globalHandler();
						}}
						class="lang-item"
					>
						{lang.label}
					</button>
				{/each}
			</div>
		{/if}
	</div>
	<div class="container">
		<slot />
		{#if $popup}
			<div class="popup">
				<svelte:component this={$popup.component} props={$popup.props} />
			</div>
		{/if}
	</div>
</main>

<style lang="scss">
	@import "../../variables.scss";
	//Mobile First
	main {
		display: flex;
		width: 100%;
		min-height: 100vh;
		height: auto;
		background-color: var(--background-2);

		.container {
			max-width: calc(100%);
			box-sizing: border-box;
			flex-grow: 1;
			height: 100%;
			background-color: var(--background-2);
			padding: 20px 20px 80px 20px;
			position: relative;
			.popup {
				display: flex;
				width: 100%;
				height: 100%;
				justify-content: center;
				align-items: center;
				position: fixed;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				z-index: 999;
			}
		}

		.container-cover {
			display: none;
			position: fixed;
			width: 100%;
			max-width: 100%;
			height: 100vh;
			max-height: 100vh;
			background-color: rgba($color: #46474b, $alpha: 0.7);
			z-index: 999;

			&.open {
				display: block;
			}
		}
		.side {
			display: flex;
			flex-direction: column;
			position: fixed;
			width: 266px;
			max-width: 266px;
			top: 0px;
			bottom: 0px;
			max-height: 100vh;
			background-color: var(--background-1);
			left: -266px;
			z-index: 999;

			&.open {
				left: 0;
				transition: left 0.5s;
			}

			#logo {
				width: 91px;
				height: 24px;
				margin: 20px 0 27px 20px;
				&:hover {
					cursor: pointer;
				}
			}

			.store-box {
				margin: 20px 0px;
			}

			.store-links-box {
				flex-grow: 1;
			}
		}

		.hamburger {
			display: flex;
			flex-direction: column;
			padding: 18px 12px 18.1px 12px;
			justify-content: space-between;
			box-sizing: border-box;
			position: fixed;
			top: 0;
			left: 0;
			width: 60px;
			height: 60px;
			background-color: var(--background-1);
			border-radius: 0 0 10px 0;
			z-index: 999;

			&:hover {
				cursor: pointer;

				span,
				&::after,
				&::before {
					background-color: var(--signature-blue);
				}
			}

			span,
			&::after,
			&::before {
				display: block;
				width: 36px;
				height: 2px;
				background-color: white;
				content: "";
				transition: background-color 0.5s;
			}
		}

		.global {
			width: 100%;
			height: 59.2px;
			box-sizing: border-box;
			padding: 0 0 29px 21px;
			margin-top: auto;
		}
		.language-box {
			position: absolute;
			display: flex;
			flex-direction: column;
			left: 71px;
			bottom: 15px;
			gap: 10px;

			.lang-item {
				border: none;
				background-color: transparent;
				color: white;
				transition: color 0.5s;
				font-weight: 300;
				text-align: left;
				&:hover {
					cursor: pointer;
					color: var(--default-hover-btn-1);
				}
			}
		}
	}

	@include DesktopSize {
		main {
			.container {
				margin-left: 266px;
				max-width: calc(100% - 266px);
				padding: 20px 20px 100px 20px;
				.popup {
					left: 266px;
					width: auto;
				}
			}

			.container-cover {
				display: none !important;
			}

			.hamburger {
				display: none;
			}

			.side {
				position: fixed;
				display: flex !important;
				top: 0;
				left: 0;
				height: 100vh;
				z-index: 9;
				.store-box {
					margin: 40px 0px;
				}

				#logo {
					width: 135px;
					height: 34px;
					margin: 33px 0 50px 50px;
				}
			}

			.global {
				width: 100%;
				height: 70.2px;
				box-sizing: border-box;
				padding: 0 0 40px 50px;
			}

			.language-box {
				position: absolute;
				left: 100px;
				bottom: 31px;

				.lang-item {
					color: white;
				}
			}
		}
	}
</style>
